import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tjbb",
  "use": "icon-tjbb-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tjbb\"><defs><style type=\"text/css\"></style></defs><path d=\"M932 848H792V400c0-30.9-25.1-56-56-56H624V232c0-30.9-25.1-56-56-56H456c-30.9 0-56 25.1-56 56v336H288c-30.9 0-56 25.1-56 56v224H120V148c0-15.5-12.5-28-28-28s-28 12.5-28 28v700c0 30.9 25.1 56 56 56h812c15.5 0 28-12.5 28-28s-12.5-28-28-28z m-644 0V624h112v224H288z m168 0V232h112v616H456z m168 0V400h112v448H624z\" p-id=\"4031\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol